import { makeStyles } from "@mui/styles";

import { colors } from "../../../styles/colors";

const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    padding: "8px 4px 16px",
    minWidth: 520,
  },
  intro: {
    color: colors.secondaryTextColor,
    fontSize: 13,
    lineHeight: "18px",
    margin: 0,
  },
  sectionBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: "uppercase",
    color: colors.primary,
  },
  toggleAll: {
    background: "transparent",
    border: "none",
    color: colors.primary,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
    padding: 0,
    textDecoration: "underline",
  },
  sectionsList: {
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 8,
    padding: 8,
    display: "flex",
    flexDirection: "column",
  },
  sectionRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    padding: "6px 4px",
    borderRadius: 4,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.surfaceHover,
    },
  },
  sectionRowLabel: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    userSelect: "none",
  },
  sectionRowTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.textPrimary,
  },
  sectionRowDesc: {
    fontSize: 12,
    color: colors.secondaryTextColor,
  },
  filtersGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
  },
  formatSelector: {
    display: "flex",
    gap: 12,
  },
  formatOption: {
    flex: 1,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: 8,
    padding: "10px 12px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    transition: "border-color .15s, background-color .15s",
    "&:hover": {
      borderColor: colors.primary,
    },
  },
  formatOptionActive: {
    borderColor: colors.primary,
    // ~6% tint of the primary blue #2563EB — hex alpha suffix (0F ≈ 6%).
    backgroundColor: colors.primary + "0F",
  },
  formatOptionLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: colors.primary,
  },
  formatOptionHint: {
    fontSize: 12,
    color: colors.secondaryTextColor,
  },
  formatWarning: {
    padding: "8px 12px",
    borderRadius: 6,
    backgroundColor: colors.warningLight,
    color: colors.warning,
    fontSize: 12,
    lineHeight: "16px",
  },
}));

export default useStyles;
